import ManagingCommitteePage from "../components/pages/ManagingCommittee";

export default ManagingCommitteePage;
